import api from "./../api"
import { InformationRequestDto } from "@/dto/information/information.request.dto"

class InformationService {
    defaultFindSort = "publicationDate,desc"

    formatDate(date) {
        if (!date || !date.includes('/')) {
            return date
        }

        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
    }

    async findActive(page = 0, size = 10, startDate, endDate) {
        const response = await api.get("/informations/active", {
            params: {
                page,
                size,
                sort: this.defaultFindSort,
                startDate,
                endDate
            }
        })

        return response.data
    }

    async findFuture(page = 0, size = 10) {
        const response = await api.get("/informations/future", {
            params: {
                page,
                size,
                sort: this.defaultFindSort
            }
        })

        return response.data
    }

    async findExpired(page = 0, size = 10) {
        const response = await api.get("/informations/expired", {
            params: {
                page,
                size,
                sort: this.defaultFindSort
            }
        })

        return response.data
    }

    async findById(id) {
        const response = await api.get(`/informations/${id}`)
        return response.data
    }

    async save(data) {
        const dto = new InformationRequestDto(data)

        dto.startDate = this.formatDate(dto.startDate)
        dto.endDate = this.formatDate(dto.endDate)

        const response = await api.post("/informations", dto)
        return response.data
    }

    async update(id, data) {
        const dto = new InformationRequestDto(data)

        dto.startDate = this.formatDate(dto.startDate)
        dto.endDate = this.formatDate(dto.endDate)

        const response = await api.put(`/informations/${id}`, dto)
        return response.data
    }

    async delete(id) {
        await api.delete(`/informations/${id}`)
    }
}

export default new InformationService()
